import React from 'react'
import { withRouter } from 'react-router'
import { Row, Col, Typography, Input } from 'antd'
import { AudioOutlined } from '@ant-design/icons'

const { Search } = Input

const { Title, Paragraph } = Typography

class Highlight extends React.Component {
    onSearch = (value) => {
        let url = `/search/site/${value}`
        this.props.history.push(url)
    }

    render() {
        return (
            <Row justify="center" style={{textAlign:"center"}}>
                <Col span={24} style={{backgroundColor:"#ADBE6D", padding:"10px"}}>
                    <Title level={2} style={{fontFamily: "Garamond"}}>Tomato</Title>
                    <Title level={5}>A comprehensive database adapted to the tomato multi-omics era</Title>
                    <Search disabled style={{ width: 600, padding: '2em' }} placeholder="input search text" onSearch={this.onSearch} enterButton />
                </Col>
            </Row>
        )
    }
}

export default withRouter(Highlight)
